import { Component, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  constructor(
		private renderer: Renderer2,  
	  
  ) { }

	  ngOnInit(): void {
			this.setBGColor();
	  }
  
 	setBGColor() {
		let shuffleColors = ["#7E78B8", "#F06793", "#FCBA63", "#51BF9D", "#44C8F5"];
		let chooseRandomColor = Math.floor(Math.random() * shuffleColors.length);
		
		this.renderer.setStyle(document.body, 'background-color', shuffleColors[chooseRandomColor]);
	} 

}
